import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Colors, helperButtonReset } from '@utex/ui-kit';

export const activeClass = css`
  color: ${Colors.red} !important;
`;

export interface TabItemProps {
  isActive?: boolean;
}

export const TabItem = styled('button')<TabItemProps>`
  ${helperButtonReset};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 25%;
  max-width: 10rem;
  min-height: 5.6rem;
  color: ${props => (props.isActive ? Colors.red : Colors.rgbaBlack50)};
  text-decoration: none;
  transition: color 0.3s, background-color 0.3s;
  cursor: pointer;

  -webkit-tap-highlight-color: ${Colors.rgbaBlack10};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

export const Text = styled('span')`
  font-size: 12px;
  line-height: 1.25;
  text-align: center;
  letter-spacing: -0.24px;
  color: inherit;
`;
